module.exports = __webpack_public_path__ + "static/media/panel.b40674f8.png";